import { render, staticRenderFns } from "./OrderFabricExtraProcessTypeTable.vue?vue&type=template&id=2dc80ba1&scoped=true&"
import script from "./OrderFabricExtraProcessTypeTable.vue?vue&type=script&lang=js&"
export * from "./OrderFabricExtraProcessTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc80ba1",
  null
  
)

export default component.exports